import { render, staticRenderFns } from "./table-cell-image.vue?vue&type=template&id=1fb4bb98&scoped=true&"
import script from "./table-cell-image.vue?vue&type=script&lang=js&"
export * from "./table-cell-image.vue?vue&type=script&lang=js&"
import style0 from "./table-cell-image.vue?vue&type=style&index=0&id=1fb4bb98&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb4bb98",
  null
  
)

export default component.exports